// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { pt, en } from './locale';

// FreBaseComponents
import { FreBaseComponentsModule } from 'fre-base-components';

import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';

// Http
import { HttpClientModule } from '@angular/common/http';

// Forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Layout
import { FlexLayoutModule } from '@angular/flex-layout';

// Mask
import { NgxCurrencyModule } from 'ngx-currency';
import { NgxMaskModule } from 'ngx-mask';

// Services
import { FreAuthService } from './_services/fre-auth.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
    declarations: [],

    imports: [
      // Angular
      CommonModule,
      // FreBaseComponents
      FreBaseComponentsModule.forRoot({
        languageData: {
          pt, en
        }
      }),
      // Material
      MatIconModule,
      MatButtonModule,
      MatSidenavModule,
      MatToolbarModule,
      MatListModule,
      MatMenuModule,
      MatCheckboxModule,
      MatFormFieldModule,
      MatTableModule,
      MatTableModule,
      MatProgressSpinnerModule,
      MatInputModule,
      MatSelectModule,
      MatRadioModule,
      MatCardModule,
      MatGridListModule,
      // Http
      HttpClientModule,
      // Forms
      FormsModule,
      ReactiveFormsModule,
      // Layout
      FlexLayoutModule,
      // Mask
      NgxCurrencyModule,
      NgxMaskModule.forRoot(),
    ],

    exports: [
      // FreBaseComponets
      FreBaseComponentsModule,
      // Material
      MatIconModule,
      MatButtonModule,
      MatSidenavModule,
      MatToolbarModule,
      MatListModule,
      MatMenuModule,
      MatCheckboxModule,
      MatFormFieldModule,
      MatTabsModule,
      MatTableModule,
      MatProgressSpinnerModule,
      MatInputModule,
      MatSelectModule,
      MatRadioModule,
      MatCardModule,
      MatGridListModule,
      // Http
      HttpClientModule,
      // Forms
      FormsModule,
      ReactiveFormsModule,
      // Layout
      FlexLayoutModule,
      // Mask
      NgxCurrencyModule,
    ],

    providers: [FreAuthService],
})

export class GlobalModule {}
